import { CONTROL_SIZE, MIN_ZOOM } from "../constants";
export var getMapOptions = function getMapOptions() {
  return {
    mapTypeControl: false,
    streetViewControl: false,
    controlSize: CONTROL_SIZE,
    minZoom: MIN_ZOOM
  };
};